import { createApp } from 'vue';
import MovToMp3Converter from '@/Components/MovToMp3Converter.vue';
import '@styles/app.css';

createApp(MovToMp3Converter).mount('#mov-to-mp3-converter');
